import { useEffect, useState } from "react";
import { Users, FolderGit2, Rocket, DollarSign, Activity } from "lucide-react";
import api from "../lib/api";
import { TopBar } from "../components/TopBar";

export default function Admin() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <div className="min-h-screen"><TopBar /><div className="flex items-center justify-center py-32 text-slate-500">Loading…</div></div>;

  const cards = [
    { label: "Total users", value: data.users, icon: Users, color: "text-indigo-400" },
    { label: "Projects", value: data.projects, icon: FolderGit2, color: "text-cyan-400" },
    { label: "Deployments", value: data.deployments, icon: Rocket, color: "text-emerald-400" },
    { label: "Paid subscriptions", value: data.paid_subscriptions, icon: Activity, color: "text-violet-400" },
    { label: "Revenue", value: `$${data.revenue}`, icon: DollarSign, color: "text-amber-400" },
  ];

  return (
    <div className="min-h-screen">
      <TopBar />
      <div className="max-w-[1600px] mx-auto px-6 py-10">
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-1">Admin panel</h1>
        <p className="text-slate-400 mb-8">Platform-wide overview and system health.</p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-10">
          {cards.map((c) => (
            <div key={c.label} className="glass rounded-xl p-5 card-hover">
              <div className="flex items-center justify-between mb-3"><span className="text-xs text-slate-500">{c.label}</span><c.icon className={`h-4 w-4 ${c.color}`} /></div>
              <div className="font-heading text-2xl font-bold">{c.value}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 glass rounded-2xl p-6">
            <h2 className="font-heading text-lg font-semibold mb-4">Recent users</h2>
            <div className="space-y-2">
              {data.recent_users.map((u) => (
                <div key={u.user_id} className="flex items-center justify-between py-2.5 border-b border-white/[0.05] last:border-0">
                  <div className="flex items-center gap-3">
                    {u.picture ? <img src={u.picture} alt="" className="h-8 w-8 rounded-full object-cover" /> : <div className="h-8 w-8 rounded-full bg-indigo-600 flex items-center justify-center text-xs font-semibold">{(u.name || u.email || "U")[0].toUpperCase()}</div>}
                    <div><div className="text-sm font-medium">{u.name || "—"}</div><div className="text-xs text-slate-500 font-mono">{u.email}</div></div>
                  </div>
                  <span className="text-xs font-mono px-2 py-0.5 rounded-full bg-indigo-500/10 text-indigo-300 capitalize">{u.plan}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="glass rounded-2xl p-6">
            <h2 className="font-heading text-lg font-semibold mb-4">System health</h2>
            <div className="space-y-3">
              {Object.entries(data.system_health).map(([k, v]) => (
                <div key={k} className="flex items-center justify-between">
                  <span className="text-sm text-slate-300 capitalize">{k}</span>
                  <span className="flex items-center gap-1.5 text-xs font-mono text-emerald-400"><span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse-glow" /> {v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
